import React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    ReferenceInput
} from 'react-admin';
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminEmailEdit = () => {

    return (
        <Edit>
            <SimpleForm>
                <TextInput name="email" source="email" validate={[required()]} fullWidth />
                <TextInput name="description" source="description" fullWidth />
                <ReferenceInput
                    label="company"
                    source="company"
                    reference="companies"
                >
                    <SelectInput optionText="name"/>
                </ReferenceInput>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}